import {IToastService} from "../../services/ToastService";
import {L} from "../../lt-ng/landcare-toolkit";
import {LTServices} from "../../lt-ng/lt-services";
import {_F} from "../../utility/func";
import {ILoginService} from "../../services/oe/login-service";
import {IPinAttribute, IPinExtraDataService} from "../../services/pin-extra-data-service";

import {
	IFeatureState
} from "../../services/feature_state";
import {ISavedFeatureService} from "../../services/features-api/saved_features";
import {IMapShareService} from "../../services/MapShareAPI";
import {ErrorMessages} from "../../utility/error-messages";
import {IReportService} from "../../services/features-api/report_service";
import {SoilInformation} from "../../lt-ng/soil-information";
import {FeaturesEvents} from "../../services/events/FeaturesEvents";
import {Coordinate} from "ol/coordinate";
import {TileWMS} from "ol/source";
import {transform} from "ol/proj";
import {Feature} from "ol";
import {processOEPointQueryResult} from "../../lt-ng/portal-services-utils";
import {GeoAppEvents} from "../events/geoapp_events";
import IMapService = LTServices.IMapService;
import friendlyNZTMCoords = _F.friendlyNZTMCoords;
import Item = L.tree.Item;
import getVisibleScienceLayers = L.tree.getVisibleScienceLayers;
import getIncludedScienceLayers = L.tree.getIncludedScienceLayers;
import getVisibleLayers = L.tree.getVisibleLayers;
import isQueryAble = L.tree.isQueryAble;
import getLayersForPointQuery = L.tree.getLayersForPointQuery;
import getLayerById = L.tree.getLayerById;
import someNodes = L.tree.someNodes;
import KoordinatesLayer = L.util.KoordinatesLayer;
import WFSLayer = L.util.WFSLayer;
import getEsriLayers = L.tree.getEsriLayers;

import filterNodes = L.tree.filterNodes;
import getLayerId = L.tree.getLayerId;
import isDefined = _F.isDefined;
import {Geometry, Point} from "ol/geom";
import {
    IPointReport,
    ISharedFeatureControlState,
    PinReport, PointReportRequestAndLayers, ReportKind
} from "../../services/ISharedFeatureState";


export interface IPointQueryScope extends ng.IScope {
	creatingReport: boolean;
    doShare();
    pinTitle: (newTitle?) => string;
    toggleAttributes: (ev: Event) => void;
	aScienceLayerIsIncluded: boolean;
	aScienceLayerIsVisible: () => boolean;
	selectedPin(): PinReport;
	sharedState(): ISharedFeatureControlState;
	activeRequest(): PointReportRequestAndLayers;
	activePinData: IPointReport;
	// savePin();
    savePinReport() : ng.IPromise<any>;
	deletePin();
	saveOnEnter(keyCode : number);

	validData : boolean|number;
	rows: () => any[];
	// unsavedPins() : boolean;
	// removeUnsavedPins();
	errorMessage: string;

	friendlyCoords() : string;
	lonLat(): [number, number];

	height(): string;
	activeLayers: {
		id: number;
		name: string;
	}[];
	scienceLayers: Item[];
	showNode(nodeId: number);

	wmsFeatureInfoURLs: Array<{name: string, url: string}>

	// saveOnBlur(pinAndExtra: PinAndExtras) : void;
    scienceLayerName(): string;
    mainAttributes: () => IPinAttribute[];
	extraAttributes(): IPinAttribute[];
    extraDataLayersEnabled(): boolean;
    showExtraAttributes: boolean;
    attributeName(name: string) : string;

	isLayerVisible(layerId: number) : boolean;
	isDefined(val: any) : boolean;
	reportHref(): string;
    generateReport();
}


export class PointQueryCtrl {
	public static $inject = [
			'$scope',
			'landcareMapService',
			'$http',
			'toastService',
			// 'pinService',
			// 'pointQueryFeatureService',
			'loginService',
        	'pinExtraDataService',
			'featureState',
			'savedFeatureService',
			'mapShareService',
			'reportService'
	];

	constructor(protected $scope: IPointQueryScope,
				protected mapService: IMapService,
				protected $http: ng.IHttpService,
				protected toastService: IToastService,
				// protected pinService: IPinService,
				// protected pointQueryFeatureService: IPointQueryFeatureService,
				protected loginService: ILoginService,
				protected pinExtraDataService: IPinExtraDataService,
				protected featureState: IFeatureState,
				protected savedFeatureService: ISavedFeatureService,
				protected mapShareService: IMapShareService,
				protected reportService: IReportService) {
        const noRows = () => [];
		let currentPin : Feature<Point> = null;

		$scope.activeLayers = [];

		$scope.isDefined = isDefined;

		$scope.activeRequest = () => featureState.getPointQueryResultsForCurrentScienceLayer();

		// attributes that are queried separate to the science layer info
		let mainAttributes: IPinAttribute[];  // above the fold attributes
		let extraAttributes: IPinAttribute[]; // below fold attributes

        $scope.$on(FeaturesEvents.reportChanged, () => {
        	$scope.activePinData = null;
        	$scope.errorMessage = null;
        	$scope.rows = noRows;
			mainAttributes = null;
			extraAttributes = null;
		});


		// $scope.extraAttributes = [];
		$scope.activePinData = null;
		$scope.showExtraAttributes = false;

		$scope.toggleAttributes = (ev : Event) => {
			ev.preventDefault();
			$scope.showExtraAttributes = !$scope.showExtraAttributes;
		};

		$scope.extraDataLayersEnabled = () => someNodes(mapService.treeData, (n) => {
            	let ls = n && n.layerService;
            	return ls && ((ls.WFSLayers || []).length || ls.koordinatesLayer);
        	});

		$scope.sharedState = () => this.featureState.sharedState();

		let getApi : (item : Item) => KoordinatesLayer|WFSLayer = (i) => {
			let ls = i.layerService;
			if (!ls) return null;
			return ls.koordinatesLayer || (ls.WFSLayers && ls.WFSLayers.length && ls.WFSLayers[0]);
		};

        let getLayersWithPointQueryAttributes = (aboveOrBelowFold: boolean) => {
			return getLayersForPointQuery(this.mapService.treeData, (api) => api.aboveFold == aboveOrBelowFold)
                .filter(n => !!n)
                .sort((a, b) => {
                	let apiA = getApi(a);
                	let apiB = getApi(b);
                	if (apiA && apiB && apiA.order - apiB.order) {
                		return apiA.order - apiB.order;
					}
                    return a.name.localeCompare(b.name);
                });
		};

        $scope.extraAttributes = () => {
        	if (!extraAttributes) {
				const mainIds = (mainAttributes || []).filter(l => !!l).map(l => l.layerId);
        		extraAttributes = this.pinExtraDataService
                    .getAttributes($scope.selectedPin().point, getLayersWithPointQueryAttributes(false))
					.filter(attr => {
						return attr && !mainIds.includes(attr.layerId);
					});
            }

			return extraAttributes;
		};

        $scope.mainAttributes = () => {
            if (!mainAttributes) {
                mainAttributes = this.pinExtraDataService
                    .getAttributes(
						$scope.selectedPin().point,
						getLayersWithPointQueryAttributes(true)
							.concat(getEsriLayers(this.mapService.treeData))
					);
            }

            return mainAttributes;
		};

		$scope.isLayerVisible = layerId => {
			let layer = getLayerById(this.mapService.treeData, layerId);
			return layer.some((l) => l.checked);
		};

		$scope.selectedPin = () => {
			const rp = featureState.getActiveReportIfPoint();
			if (!rp) return;

			return rp;
		};

		$scope.$on(GeoAppEvents.featureClicked, () => {
			// const newData = info.newValue && info.newValue.data;
			/*if (!$scope.selectedPin || pinsAreTheSame($scope.selectedPin.data, newData)) {
				$scope.selectedPin = info.newValue;
				return;
			}
			$scope.selectedPin = info.newValue;*/

			$scope.errorMessage = '';
			$scope.activePinData = null;
			$scope.wmsFeatureInfoURLs = [];
			$scope.rows = noRows;

			const ar = this.featureState.sharedState().activeReport;
			const maybePin = ar && ar.kind === ReportKind.pin && ar.point;

			if (maybePin) {
				$scope.validData = true;
			} else {
				currentPin = null;
				$scope.validData = false;
				mainAttributes = null;
                extraAttributes = null;
				return;
			}

			if (maybePin == currentPin) {
				return;
			}
            mainAttributes = null;
			extraAttributes = null;
			currentPin = maybePin;
		});

		/*$scope.saveOnBlur = (aPin) => {
			if (aPin.data.id) {
				this.loginService.requestLogin().then( () => {
					this.pinService.savePin(aPin);
				});
			}
		};*/

		let reportInstance = null;
		let reportInstanceIsForLayers: string = null;
        let showReport = () => {
            if (reportInstance && reportInstance['id']) {
                let id = reportInstance['id'];
                $scope.$emit('showFragReport', id, true);
            }
        };

        $scope.creatingReport = false;

        $scope.generateReport = _F.debounce(() => {
        	$scope.creatingReport = true;

        	$scope.savePinReport().then(() => {
                let rp = featureState.getActiveReportIfPoint();
                let subject = rp && rp.userFeatures && rp.userFeatures.userFeature;
                if (!subject) return;

				let layerNames = this.featureState.getScienceLayersForAreaQuery().map(l => l.layerService.layerName)
					.sort().join(',');

				if (reportInstance && reportInstance['subject']['id'] == subject.id && reportInstanceIsForLayers == layerNames) {
					showReport();
					return;
                }

                return this.reportService.createReportForName(subject, 'point_report', subject.title, layerNames)
                    .then(report => {
                    	reportInstanceIsForLayers = layerNames;
                        reportInstance = report;
                        showReport();
                    }, () => {
                        let msg = 'Failed to generate report';
                        this.toastService.showToast(msg);
                    });
			}).finally(() => {
				$scope.creatingReport = false;
			})
		}, 750, true);

		$scope.reportHref = () => {
			let pointReportId = 2;
			let params = new URLSearchParams();
			const [x, y] = $scope.selectedPin().point.getGeometry().getCoordinates();
			params.set('x', `${x}`);
			params.set('y', `${y}`);

			return `/frag/report/${pointReportId}?${params.toString()}`
		};

		let responseIsSmap = (data) => {
			return data.response && data.response.layers.some((l) => l.name.indexOf('smap') == 0);
		};

        function processSmapResult(data: SoilInformation, scienceLayers: L.tree.Item[]) : any[] {
			return [{
                name: scienceLayers[0].name,
                data: data.rows().map((row) => {
                return {
                    name: row.soilName,
					value: `Area ${row.proportion}% Confidence ${row.confidence}`,
                    description: row.description,
					href: row.factSheetURL
                }
            	})
			}];
        }

        let displayResponse = (event, report: PinReport, data : IPointReport, queriedLayers: Item[]) => {
			$scope.activePinData = data;
			let feature = report.point;
			// let pin = feature.get('pin');

			let coordinate : Coordinate = feature.getGeometry().getCoordinates();

			let result = [];

			if (!queriedLayers.length) {
				$scope.activeLayers = [];
			}

			try {
				if (responseIsSmap(data)) {
					result = processSmapResult(new SoilInformation(coordinate, data.response as any), queriedLayers);
				} else {
                    result = processOEPointQueryResult(data, queriedLayers, mapService.treeData);
				}
			} catch (e) {
				console.warn(e);
			}

			console.log(result);

			$scope.rows = () => result;
			$scope.validData = true;
			$scope.errorMessage = '';

			let customWMSLayers = getVisibleLayers(mapService.treeData)
				.filter((n) => n.isCustom)
				.filter((n) => n.layer.getSource() instanceof TileWMS);
			let view = mapService.map.getView();
			let resolution = view.getResolution();
			$scope.wmsFeatureInfoURLs = customWMSLayers.map((item : Item) => {
				let l = item.layer;
				let source = <TileWMS> l.getSource();

				return {
					name: item.name,
					url: source.getFeatureInfoUrl(
						coordinate,
						resolution,
						"EPSG:2193",
						{	INFO_FORMAT:'text/plain' })
				};
			});
		};

        $scope.$watch('activeRequest()', (event) => {
            const report = $scope.sharedState().activeReport;
            const request = $scope.activeRequest();
            if (report.kind != ReportKind.pin || !request) {
            	$scope.activePinData = null;
            	return;
			}

			request.request.request.then((reportData: IPointReport) => {
				if (request == $scope.activeRequest()) {
					displayResponse(event, report, reportData, request.queriedLayers);
				}
			}, () => {
				$scope.errorMessage = ErrorMessages.reportRequestFailed;
				$scope.activePinData = null;
			});
		});

		$scope.scienceLayers = [];
		$scope.aScienceLayerIsIncluded = false;

		function updateIncluded() {
			$scope.scienceLayers = getIncludedScienceLayers(mapService.treeData)
				.filter(isQueryAble);

			$scope.aScienceLayerIsIncluded = $scope.scienceLayers.length > 0;
		}

		$scope.$on('layerIncluded:change', updateIncluded);

		let updateActiveLayers = () => {
            let scienceLayers = getVisibleScienceLayers(mapService.treeData);
            if (!scienceLayers.some(isQueryAble)) scienceLayers = [];
            $scope.activeLayers = scienceLayers
                .map((i) => {
                    return {
                        id: i.id,
                        name: i.name
                    }
                });
		};

		let updateLayers = () => {
			updateIncluded();
            updateActiveLayers();
		};

		mapService.mapPromise.then(() => {
			updateLayers();
		});
		$scope.$on('onTreeChange', updateLayers);

		$scope.$on('scienceLayer', (/*ev, info : {oldValue: Item, newValue: Item}*/) => {
			updateActiveLayers();
			updateIncluded();
		});

		const getCoordinates: () => Coordinate = () => $scope.selectedPin().point.getGeometry().getCoordinates();

		$scope.friendlyCoords = () => {
			try{
				return friendlyNZTMCoords(getCoordinates());
			} catch (e) {
				return '';
			}
		};

		$scope.lonLat = () => {
			return  $scope.selectedPin ? <[number, number]> transform(
				getCoordinates(),
                mapService.map.getView().getProjection(),
                'EPSG:4326') : null;
		};

		$scope.height = ()  => {
			try {
				return Math.round($scope.activePinData.response.pointHeight).toString();
			} catch (e) {
				return '';
			}
		};

		$scope.deletePin = function() {
			let pin = $scope.selectedPin();
			if (pin) {
				const uf = featureState.getActiveReportIfPoint().userFeatures;
				savedFeatureService.deleteFeature(uf);
			}
		};

		const getActiveMapFeature : (() => Feature<Geometry>[]) = () => {
			const rp = this.featureState.getActiveReportIfPoint();
			const savedFeatures = rp && rp.userFeatures && rp.userFeatures.mapFeatures;
			if (savedFeatures) return savedFeatures;

			let pin = $scope.selectedPin();
			return this.savedFeatureService.featuresSource.getFeatures()
				.filter((f) => f.get('pin') == pin);
		};

		$scope.doShare = () => {
			const features = getActiveMapFeature();
			if (!features || !features.length) return;

			let share = this.mapShareService.createFeaturesSharePaylod(features, '', ['pin']);
			this.mapShareService.createAreaReportShare(share)
				.then((result) => {
					$scope.$root.$broadcast('showShareModal', result);
				});
		};

		$scope.pinTitle = function(newTitle) {
			// a getterSetter function that can be used by ng-model
			// see https://docs.angularjs.org/api/ng/directive/ngModel#binding-to-a-getter-setter
            const rp = featureState.getActiveReportIfPoint();
            const uf = rp && rp.userFeatures;
			const point = rp.point;

			if (arguments.length) {
				// set
				if (uf) {
					return (uf.userFeature.title = newTitle);
				}

				if (point && point.get('pin')) {
					return (point.get('pin').title = newTitle);
				}
			} else {
                if (uf) {
                    return uf.userFeature.title;
                }

				if (point) point.set('pin', point.get('pin') || {});

                return (point && point.get('pin') && point.get('pin').title)
					|| point.get('name');
			}
		};

		$scope.savePinReport = () => {
			$scope.pinTitle($scope.pinTitle() || 'unnamed pin');

			let rp = this.featureState.getActiveReportIfPoint();

			let uf = rp && rp.userFeatures;
			if (uf) {
				return this.savedFeatureService.saveFeature(uf)
					.then(() => {
						if (uf.userFeature.id) {
							const data = rp.point.get('pin') || {};
							data.id = parseInt(uf.userFeature.id);
							rp.point.set('pin', data);
						}
					});
			}

			let pin = $scope.selectedPin();
			let mapFeatures = rp.point ? [rp.point] : this.savedFeatureService.featuresSource.getFeatures()
                .filter((f) => f.get('pin') == pin);

			let projection = this.mapService.map.getView().getProjection();

			let newUserFeature = this.savedFeatureService.createNewFeature(
				(pin.point.get('pin') || { title: '' }).title,
				mapFeatures,
				'custom',
				projection);

			const reportForPin = $scope.sharedState().activeReport;

            return newUserFeature.then((userFeature) => {
            	const d = pin.point.get('pin') || {};
				d.id = parseInt(userFeature.id);
				pin.point.set('pin', d);
            	let uf = {
                    visible: true,
                    deleting: false,
                    userFeature,
                    mapFeatures
                };
                const savePromise = this.savedFeatureService.saveFeature(uf);

                if (reportForPin && featureState.getActiveReportIfPoint() == reportForPin) {
					reportForPin.userFeatures = uf;
                }

                return savePromise;
			});
		};

		$scope.saveOnEnter = (keyCode) => {
			if (keyCode === 13) {
				this.loginService.requestLogin().then(
					() => {
						$scope.savePinReport()
					}
				);
			}
		};

		/*let getUnsavedPins = () => pinService
			.getPinSource()
			.getFeatures()
			.map((f) => f.get('pin'))
			.filter((pin) => {
				return pin && !pin.ID;
			});

		$scope.unsavedPins = () => {
			return getUnsavedPins().length > 0;
		};*/

		/*$scope.removeUnsavedPins = () => {
			let toDelete = getUnsavedPins();
			toDelete.forEach((p) => pinService.deletePin(p));
			if (toDelete.indexOf($scope.selectedPin()) !== -1) {
				pinService.selectPin(null);
			}
		};*/

		$scope.showNode = (layerId: number) => {
			if (layerId) {
				let candidates = filterNodes(mapService.treeData, layer => {
					const id = getLayerId(layer);

					return id === layerId;
				});

				if (candidates.length) {
					candidates[0].checked = true;
					$scope['showSelected'](candidates[0], true, false);
				}
			}
		};

		/*$scope.$on('features:backToStart', () => {
			pinService.selectPin(null);
		});*/

		$scope.scienceLayerName = () => {
			return $scope.activeLayers.map((l) => l.name).join(', ');
		}
	}
}
